import { Button, MultiSelect, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import type { JSX } from "react";

import TagsInput from "../TagsInput";
import { LANGUAGES, type Language, languageLabel } from "../utils";
import classes from "./SearchForm.module.css";

export interface IFormValues {
    query: string;
    tags: string[];
    languages: Language[];
    title: string;
    author: string;
    publication: string;
}

interface IProps {
    handleSubmit: (values: IFormValues) => void;
    initialValues?: IFormValues;
    fetching: boolean;
}

function SearchForm({ handleSubmit, initialValues, fetching }: IProps): JSX.Element {
    const form = useForm<IFormValues>({
        initialValues: initialValues ?? {
            query: "",
            tags: [],
            languages: [],
            title: "",
            author: "",
            publication: "",
        },
    });

    return (
        <form onSubmit={form.onSubmit(handleSubmit)}>
            <div className={classes.grid}>
                <TextInput placeholder="Title" {...form.getInputProps("title")} />
                <TextInput placeholder="Author" {...form.getInputProps("author")} />
                <MultiSelect
                    placeholder="Languages"
                    data={LANGUAGES.map((lang) => ({ value: lang, label: languageLabel(lang) }))}
                    clearable
                    {...form.getInputProps("languages")}
                />
                <TextInput placeholder="Publication" {...form.getInputProps("publication")} />
                <TagsInput form={form} label={""} placeholder="Tags" />
                <TextInput placeholder="Content" {...form.getInputProps("query")} className={classes.content} />
                <Button type="submit" disabled={fetching}>
                    Search
                </Button>
            </div>
        </form>
    );
}

export default SearchForm;
